<template>
  <div class="acceptWrap">
    <div class="accept">
      <div class="title">学生本人郑重确认并承诺：</div>
      <div>
        1.&emsp;&emsp;本人已阅读中央广播电视中等专业学校招生简章，理解并认可中央广播电视中等专业学校面向社会开展中等职业学历教育，属成人教育范畴。
      </div>
      <div>
        2&emsp;&emsp;本人已了解报名专业入学条件要求，本人报名时所持前置学历属于国民教育系列，并符合其他报名入学条件要求。
      </div>
      <div>
        3.&emsp;&emsp;本人愿意按要求提交相关材料，接受中央广播电视中等专业学校的入学资格审核。
      </div>
      <div>
        4.&emsp;&emsp;本人承诺所提供的一切证明材料和填写的个人信息真实、有效，若有不实或不符合条件情况，一经查实，本人愿意承担完全责任和因此产生的一切后果（包括但不限于取消学籍、不予颁发毕业证书、追回各类证件和不予退还已交纳费用等）。
      </div>
      <div>
        5.&emsp;&emsp;以上承诺真实、有效，是承诺人本人的真实意愿。
      </div>
    </div>
    <div class="next">
        <van-button type="info" block class="nextBtn" @click="goBack">返回</van-button>
      </div>
  </div>
</template>

<script>
export default {
  name: "Accept",
  data() {
    return {
    };
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    clickSubmit() {
      if (!this.checkbox) {
        this.$toast.fail("请勾选并同意入学承诺书");
        return
      }
      this.submitQm()
    },
    // 提交签名
    submitQm() {

    }
  },
};
</script>
<style scoped>
.van-cell {
  width: 50px;
}
.next {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 60px;
  padding: 0 10px;
  background-color: #fff;
}
.next .nextBtn {
  background-color: red;
  border: none;
  font-size: 17px;
  font-weight: bold;
}
.acceptWrap {
  box-sizing: border-box;
  padding-bottom: 60px;
}
.accept {
	font-size: 14px;
	color: #2a2a2a;
	text-align: justify;
	line-height: 20px;
  padding: 10px 20px 20px;
  text-indent: 32px;
}
.accept div {
  margin-bottom: 5px;
}
.accept .title {
  font-weight: bold;
  margin: 10px 0;
  text-indent: 0;
}
</style>